import PatientGeneric from '../assets/images/patient-generic-1.png'
import KneeIcon from '../assets/icons/knee-icon.svg'
import BabyBottleIcon from '../assets/icons/baby-bottle-icon.svg'
import HeadIcon from '../assets/icons/head-icon.svg'
import PregnantIcon from '../assets/icons/pregnant-icon.svg'
import OCNZ from '../assets/images/ocnz-logo.svg'
import Button from '../components/Button/Button'
import StaffFlat from '../assets/images/staff.svg'

const treatmentCards = [
  {
    icon: KneeIcon,
    title: 'ACCIDENTS & INJURIES',
    text: 'Assisting in the recovery from accidents and injuries by addressing musculoskeletal issues, reducing pain, and promoting healing.',
  },
  {
    icon: HeadIcon,
    title: 'CHRONIC PAIN',
    text: 'Relieve chronic pain by improving joint mobility, reducing muscle tension, and encouraging optimal health.',
  },
  {
    icon: PregnantIcon,
    title: 'PRE- & POST PARTUM',
    text: 'Providing vital support for pregnancy and postpartum, addressing discomforts and aiding recovery for expectant and new mothers alike.',
  },
  {
    icon: BabyBottleIcon,
    title: 'BABIES, INFANTS + KIDS',
    text: 'Aid infants and toddlers by addressing issues such as colic, reflux, and musculoskeletal imbalances, facilitating overall health.',
  },
]

function Home() {
  return (
    <div>
      <HelpSection />
      <TeamSection />
      <TreatmentSection />
      <CareSection />
    </div>
  )
}

const HelpSection = () => (
  <section className='container mb-12 lg:mb-30'>
    <div className='grid items-center gap-8 lg:grid-cols-2'>
      <div className='mb-4 lg:mb-0 lg:pr-[72.5px]'>
        <img
          src={PatientGeneric}
          className='mx-auto block h-auto max-w-full'
          alt='Patient'
          width='700'
          height='500'
        />
      </div>
      <div className='mb-5 lg:mb-0 lg:pl-[72.5px]'>
        <h2 className='mb-4 text-lg font-bold leading-none text-blue-dark'>HOW CAN WE HELP</h2>
        <p className='mb-8 text-blue-dark'>
          We provide personalised osteopathic treatments for individuals of all ages, utilising techniques
          such as massage, stretching, gentle manipulation, and more to enhance functionality and reduce pain.
          Our mission is to deliver effective, friendly care that addresses the root cause of symptoms and
          promotes overall well-being.
        </p>
        <Button label='LEARN MORE' buttonType='secondary-dark' navigateTo='/services' />
      </div>
    </div>
  </section>
)

const TeamSection = () => (
  <section className='mb-5 bg-brand-gradient-reverse px-4 py-4 lg:container lg:bg-none lg:px-[15px] lg:py-0'>
    <div className='lg:rounded-lg lg:bg-brand-gradient-staff'>
      <div className='grid items-center gap-12 lg:grid-cols-2 lg:px-12'>
        <div className='lg:col-start-2 lg:my-12'>
          <img
            src={StaffFlat}
            className='mx-auto block h-auto max-w-full'
            alt='Lakes Osteopathy team'
            width='700'
            height='500'
          />
        </div>
        <div className='mb-5 text-white lg:col-start-1 lg:row-start-1 lg:mb-0'>
          <h2 className='mb-3 text-lg font-bold leading-none'>MEET THE TEAM</h2>
          <p className='mb-3'>
            With a collective experience of over 15 years. Together we provide the best management for your
            pain.
          </p>
          <Button label='VIEW TEAM' buttonType='secondary-light' navigateTo='/team' />
        </div>
      </div>
    </div>
  </section>
)

const TreatmentSection = () => (
  <section className='container'>
    <h2 className='mb-4 text-lg font-bold text-neutral-brand md:mb-5'>WHAT WE TREAT</h2>
    <div className='mb-5 grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-4'>
      {treatmentCards.map((card) => (
        <div
          className='relative h-auto w-full cursor-pointer overflow-hidden rounded-lg border-2 border-teal-border bg-teal-pale px-4 pb-6 pt-6 text-teal-dark md:h-[337px] md:w-[262px] md:pb-10'
          key={card.title}
        >
          <img className='mb-4' src={card.icon} alt={`Icon for ${card.title}`} />
          <h2 className='mb-3 text-lg font-bold'>{card.title}</h2>
          <p>{card.text}</p>
        </div>
      ))}
    </div>
  </section>
)

const CareSection = () => (
  <section className='container mb-4 text-blue-dark'>
    <div className='items-center md:flex'>
      <div className='mb-3 text-center md:hidden'>
        <h2 className='text-lg font-semibold'>PROVIDING THE BEST CARE</h2>
      </div>
      <div className='mb-3 flex justify-center text-center md:mb-5 md:w-auto md:flex-none'>
        <img src={OCNZ} alt='OCNZ logo' className='mx-2 h-32' />
      </div>
      <div className='md:flex-1'>
        <h2 className='mb-4 hidden text-lg font-semibold md:block'>PROVIDING THE BEST CARE</h2>
        <p>
          We're ACC registered and adhere to the regulations set by the Osteopathic Council of New Zealand,
          ensuring your care meets the highest standards.
          <strong> Plus, there's no need for a referral to visit us.</strong>
        </p>
      </div>
    </div>
  </section>
)

export default Home
